import { render, staticRenderFns } from "./ActStatus.vue?vue&type=template&id=0aa87e2e&scoped=true&"
import script from "./ActStatus.vue?vue&type=script&lang=js&"
export * from "./ActStatus.vue?vue&type=script&lang=js&"
import style0 from "./ActStatus.vue?vue&type=style&index=0&id=0aa87e2e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa87e2e",
  null
  
)

export default component.exports